import { useEffect } from 'react';

/**
 * Adds `.is-visible` to elements with `.hpv2-reveal` when they enter the viewport.
 */
export default function useRevealOnScroll(rootRef) {
  useEffect(() => {
    const root = rootRef?.current;
    if (!root) return undefined;

    const nodes = Array.from(root.querySelectorAll('.hpv2-reveal'));
    if (!nodes.length) return undefined;

    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    nodes.forEach((node) => observer.observe(node));

    return () => observer.disconnect();
  }, [rootRef]);
}
